import type { StyleSystemProps } from '@withjoy/joykit';
import { Flex, LinkV2, styled } from '@withjoy/joykit';

export const FooterMenuWrapper = styled(Flex)``;
const footerMenuWrapperStyles: StyleSystemProps = {
  columnGap: 6,
  rowGap: 6,
  flexDirection: ['column', null, null, 'row'],
};

export const StyledLinkV2 = styled(LinkV2)`
  text-decoration: none;
  color: white;
  &:visited {
    color: white;
  }
  &:hover {
    color: ${props => props.theme.colors.mono5};
  }
  &:active {
    color: white;
  }
`;

export const styles = {
  footerMenuWrapper: footerMenuWrapperStyles,
};
